(function() {
	var selectors = {
		modal: '.js-cookie-configurator',
	    selectionTrigger: '.js-cookie-configurator-selection-trigger',
	    shortcutTrigger: '.js-cookie-configurator-shortcut-trigger',
	    shortcutForm: '.js-cookie-configurator-shortcut',
    	selectionForm: '.js-cookie-configurator-selection'
	};

	function isMatchingTrigger (element, selector) {
	    if (!element || !selector) {
	        return false;
	    } else {
	        return element.matches(selector + ', ' + selector + ' *');
	    }
	}

	var modal = document.querySelector(selectors.modal);
	if (!modal) return;

	var shortcutForm = modal.querySelector(selectors.shortcutForm);
    var selectionForm = modal.querySelector(selectors.selectionForm);

	/* [1] */
	modal.addEventListener('click', function (e) {
	    var isSelectionTrigger = isMatchingTrigger(e.target, selectors.selectionTrigger);
	    var isShortcutTrigger = isMatchingTrigger(e.target, selectors.shortcutTrigger);

	    if (isSelectionTrigger) {
	        goTo('selection');
	    } else if (isShortcutTrigger) {
	        goTo('shortcut');
	    }
	}, true);

	/* [2] */
	modal.addEventListener('submit', function (e) {
	    e.preventDefault();
	    submitForm(e.target);

	    /* [2.3] */
	    close();
	}, true);


    function submitForm (form) {
        var formData = new FormData(form);
        var url = form.action.value || form.action || (window.location.origin + window.location.pathname);

        /* [2.2] */
        fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json'
            },
            body: formData
        })
            .then(function (resp) {
            	return resp.json();
            })
            .then(function (resp) {
                /* [2.2] */
                if (window.dataLayer) {
                    /* [2.1] */
                    var consentKeys = modal.dataset.consentKeys.split(',');
                    var consentData = consentKeys.reduce(function (acc, currentKey) {
                        acc[currentKey] = formData.get(currentKey) || 'false';
                        return acc;
                    }, {});

                    window.dataLayer.push(consentData);
                }
            });
    }

    // ====================================================================== //
    // Actions
    // ====================================================================== //

    /**
     * NOTE: once we want to enable the possibility for the user to re-edit
     *       their cookie consents, let’s just add a logic here to reopen
     *       the panel once a link is hit and put a focus inside the configurator.
     *       The rest of the logic is already ensured.
     */
    // function open () {}

    /**
     * Closes the cookie configurator and gets the focus back on the page.
     */
    function close () {
        modal.hidden = true;

        document.body.tabIndex = -1;
        document.body.focus({
            preventScroll: true
        });
    }

    /**
     * Shows the appropriate panel based on user’s actions.
     * 1. Shows the selection panel where the user can select the options.
     * 2. Shows the shortcut panel, where the user can quickly dismiss the cookie configurator.
     */
    function goTo (targetHandle) {
        /* [1] */
        if (targetHandle === 'selection') {
            shortcutForm.hidden = true;
            selectionForm.hidden = false;

            selectionForm.focus({
                preventScroll: true
            });
            // If we go to the selection, already set a cookie with the values rejected
            submitForm(selectionForm);
        /* [2] */
        } else if (targetHandle === 'shortcut') {
            shortcutForm.hidden = false;
            selectionForm.hidden = true;

            shortcutForm.focus({
                preventScroll: true
            });
        }
    }
})();
